import React, { Component } from "react";
import { Grid, Button, GridColumn, Icon } from "semantic-ui-react";
import EventsBackgroundColor from "../Shared/EventsBackgroundColor";
import { BrowserView, MobileView, isBrowser, isMobile, isSmartTV, withOrientationChange } from "react-device-detect";
import OwlCarousel from "react-owl-carousel2";
// import "react-owl-carousel2/style.css";
const { 
  getCategory,
  fontSizeOptions,
  fontSizeTitle,
  fontSizeCategory,
  fontSizeDesc,
  ImageSizeOptions,
  getMonthName
} = require("../Shared/utils");

function eventColor(category) {
  //console.log("rowrow", row)
  if (category.toLowerCase() == "historical") {
    return "#a22a2a";
  } else if (category.toLowerCase() == "architecture") {
    return "#609f9f";
  } else if (category.toLowerCase() == "visual arts") {
    return "#D97126";
  } else if (category.toLowerCase() == "film") {
    return "#C5C5C5";
  } else if (category.toLowerCase() == "music") {
    return "#DEA821";
  } else if (category.toLowerCase() == "dance") {
    return "#D78692";
  } else if (category.toLowerCase() == "theater") {
    return "#8457a8";
  } else if (category.toLowerCase() == "broadcast arts") {
    return "#5267ad";
  } else if (category.toLowerCase() == "literature") {
    return "#7e4e35";
  } else {
    return "#696969";
  }
}

class PeriodEventPeriod extends Component {
  state = {
    periodList: []
  }


  componentWillMount = () => {
    console.log("propsPeriodEventMountPeriod", this.props);
    var id = window.location.pathname.split('/')
    var periodId = id[2]

    var periodFilter =  this.props.location.state.items.filter((item)=>{
      return item.period_id == periodId
    })
    console.log('periodFilter',periodFilter)

    var arr = []
    // periodFilter[0].sub_period.map((item)=>{
    //   item.value.event.map((i)=>{
    //     // console.log("date", JSON.stringify(i.event.dates))
    //     // var dates = JSON.parse(i.event.dates)
    //     arr.push(i.event)
    //     i.event['category'] = i.event.categories.length == 0 ? '' : i.event.categories[0]
    //     // i.event['dates'] = dates
    //   })
    // })

    periodFilter[0].sub_period.map((item)=>{
      item.value.category_page.event_list.map((x) => {
        x.events.map((ev)=>{
          ev.map((e)=>{
            arr.push(e.value.event)
            e.value.event['category'] = e.value.event.categories.length == 0 ? '' : e.value.event.categories[0]
          })
        })
      })
    })

    console.log('arrarr',arr)
    
    this.setState({
      periodList: arr,
      periodName: periodFilter[0].period_name,
      period: periodFilter[0]
    })
  }

  handleClick = (value) => {
    window.location.replace(`/epa_timeline/#id${value}`);
  }

  render() {
    const options = {
      items: 1,
      nav: true,
      rewind: true,
      autoplay: true,
      navElement: '<div>smaple</div>'
  };
  

  const events = {
    onDragged: function(event) {},
    onChanged: function(event) {}
  };
    console.log("statePeriodEvent", this.state);
    var { periodList, periodName, period } = this.state
    var period_name = periodName.replace(/\s/g,'').toLowerCase()
    var regex = /(<([^>]+)>)/gi;
    var categoryColor = "";

    return (
      <div>


<div id="carouselExampleControls" className="carousel slide" data-ride="carousel" data-interval="false">
  <div className="carousel-inner">
  {periodList.map((item, ind)=>{
    console.log("itemitemitemitemitem",item)
      return (

        <div className={`carousel-item ${ind == 0 ? 'active' : ''}`}>
          <div
          className={`container-fluid col-xl-12 period-container bg-img p-0`}
          style={{
            backgroundImage: `url('${period.background_image.meta.download_url}')`,
            // backgroundImage: `url('${item.photo == null ? '': period.background_image.meta.download_url}')`,
            backgroundColor: `${period.period_color}`,
            backgroundBlendMode: "soft-light",
            width: '100vw'
          }}
        >
         
          <EventsBackgroundColor category={categoryColor} className={"h-100"}>
            <Grid className="m-0">
            <Grid.Column width={6}>
              {/* <Button className="rounded-0 btn-event-back p-1" content="Scroll Down" onClick={this.handleClick.bind(this, item.id)}>
                <Icon name="long arrow alternate left" />
                Back
              </Button> */}
            </Grid.Column>
            <Grid.Column width={10} className="pt-3">
              <p className="event-slider-period-category text-white text-uppercase text-right ">
                {period.period_slider_display_name}
              </p>
            </Grid.Column>
          </Grid>

          <div className="center-div">
          {item.photo == null ? '' : 
              (
                  <Grid className="m-0">
                  <Grid.Column width={16} className="p-0">
                  <img className="event-slider-image" align="left" src={item.photo.url} />
                  <div className="font-style-7 text-white m-auto pt-1 text-center" dangerouslySetInnerHTML={{ __html: `${item.photo.caption}` }} />
                </Grid.Column>
              </Grid>
              )
            }
            
            <Grid className="m-0">
              <Grid.Column width={2}></Grid.Column>
              <Grid.Column width={11} className="mt-0 ml-3 px-0 pb-0 pt-2 m-auto">
                <div className="mt-4">
                  <p className="event-title-historical text-white mt-3">
                    {item.display_name == "" || item.display_name == null
                                      ? item.complete_start_date
                                      : item.display_name}
                    <span className={`event-category text-white  ${getCategory(item.categories[0].id) == '' ? "d-none" : ""}`}>| {getCategory(item.categories[0].id)}</span>
                  </p>
                </div>
                <div className="col-md-6 mt-2 p-0">
                  <hr className="hr-gold mb-2 mt-2" />
                </div>
    
                <p className="event-description-historical text-white font-style-3">
                  {/* {item.description.replace(regex, "")} */}
                  <div dangerouslySetInnerHTML={{ __html: `${item.description}` }} />
                </p>
              </Grid.Column> 
              <Grid.Column width={2}></Grid.Column>
            </Grid>
          
          </div>
          {/* <Grid.Column width={16} className={item.photo == null ? 'd-block': 'd-none'
             }>
              <img
                className="event-slider-category-image"
                align="left"
                src={item.photo == null ? period.background_image_category.meta.download_url: ''}
              />
            </Grid.Column> */}
            
          </EventsBackgroundColor>
          <a className="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
            <span className="navicon-icon">
              <svg width="18px" height="17px" viewBox="0 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
                <g id="prev" transform="translate(8.500000, 8.500000) scale(-1, 1) translate(-8.500000, -8.500000)">
                    <polygon className="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                    <polygon className="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                    <path d="M-1.48029737e-15,0.56157424 L-1.48029737e-15,16.1929159 L9.708,8.33860465 L-2.66453526e-15,0.56157424 L-1.48029737e-15,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z"></path>
                </g>
              </svg>
            </span>
          </a>
          <a className="carousel-control-next zIndex-99" href="#carouselExampleControls" role="button" data-slide="next">
            <span className="navicon-icon">
              <svg width="18px" height="17px" viewBox="-1 0 18 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/1999/xlink">
                  <g>
                      <polygon className="arrow" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                      <polygon className="arrow-fixed" points="16.3746667 8.33860465 7.76133333 15.3067621 6.904 14.3175671 14.2906667 8.34246869 6.908 2.42790698 7.76 1.43613596"></polygon>
                      <path d="M-4.58892184e-16,0.56157424 L-4.58892184e-16,16.1929159 L9.708,8.33860465 L-1.64313008e-15,0.56157424 L-4.58892184e-16,0.56157424 Z M1.33333333,3.30246869 L7.62533333,8.34246869 L1.33333333,13.4327013 L1.33333333,3.30246869 L1.33333333,3.30246869 Z"></path>
                  </g>
              </svg>
            </span>
          </a>

          <div class="event-back">
            <div class="event-back-content">
              <Button className="rounded-0 btn-event-back mr-3 p-0 font-weight-bold" content="Scroll Down" onClick={this.handleClick.bind(this, period.period_id)}>
                <Icon name="long arrow alternate left" />
                Back
              </Button>
            </div>
          </div> 
        </div>
      </div>
      )
    })}
  </div>
  </div>
</div>

    );
  }
}

export default PeriodEventPeriod;
